import React, { useCallback, useState } from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";

import Permission from "Components/Common/Permission";
import ExportLoadingModal from "Components/Common/ExportLoadingModal";
import { exportGovtRequestsToCsv } from "common/services/govt-requests.service";
import { toast } from "react-toastify";
import GovernmentRequestsImportModal from "./GovernmentRequestsImportModal";

interface GovernmentRequestsImportProps {
  apiParams: any;
  onImported?: () => void;
}

const GovernmentRequestsImport: React.FC<GovernmentRequestsImportProps> = ({
  apiParams,
  onImported,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [exporting, setExporting] = useState(false);

  const exportToCsv = useCallback(async () => {
    setExporting(true);
    try {
      const response: any = await exportGovtRequestsToCsv({
        filters: apiParams?.filters,
        sort: apiParams?.sort,
      });
      const objectUrl = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = objectUrl;
      link.setAttribute("download", "Government_Requests_Export.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
      toast.error("An error occurred while exporting government requests");
    } finally {
      setExporting(false);
    }
  }, [apiParams]);

  return (
    <>
      <UncontrolledDropdown>
        <DropdownToggle tag="button" className="btn btn-light">
          <i className="ri-more-fill"></i>
        </DropdownToggle>
        <DropdownMenu end>
          <Permission resource="government-request" action="import">
            <DropdownItem onClick={() => setIsOpen(true)}>
              <i className="ri-upload-2-line me-1"></i>
              Import
            </DropdownItem>
          </Permission>
          <Permission resource="government-request" action="exportToCsv">
            <DropdownItem onClick={exportToCsv}>
              <i className="ri-download-2-line me-1"></i>
              Export
            </DropdownItem>
          </Permission>
        </DropdownMenu>
      </UncontrolledDropdown>
      <GovernmentRequestsImportModal
        isOpen={isOpen}
        toggle={() => setIsOpen((current) => !current)}
        onImported={onImported}
      />
      <ExportLoadingModal show={exporting} onCloseClick={() => {}} />
    </>
  );
};

export default GovernmentRequestsImport;
